export const jp = {
    store: "店",
    meal: "食事",
    users: "ユーザー",
    user: "ユーザー",
    layout: "レイアウト",
    analytics: "分析",
    settings: "設定",
    storeDetails: "店舗の詳細",
    advanced: "高度",
    name: "名前",
    quantity: "数量",
    address: "住所",
    email: "メール",
    phone: "電話",
    galleryForCustomer: "顧客向けギャラリー/広告",
    customMealCategory: "カスタム食事カテゴリー",
    storeType: "店舗タイプ",
    currency: "通貨",
    add: "追加",
    print: "印刷",
    sessions: "セッション",
    orders: "注文",
    customerFacingScreen: "顧客向けスクリーン",
    cashierView: "レジビュー",
    kitchenView: "キッチンビュー",
    layoutView: "レイアウトビュー",
    history: "履歴",
    noOrderRecordsExist: "注文記録が存在しません",
    noSessionRecordsExist: "セッション記録が存在しません",
    updateMenu: "メニューを更新する",
    updateMenuSuccessfully: "メニューを成功に更新しました",
    updateMenuTooltip: "食事の変更ごとに最新のメニューをサーバーにアップロードします",
    serving: "提供中",
    active: "アクティブ",
    inactive: "非アクティブ",
    amount: "金額",
    total: "合計",
    table: "テーブル",
    payment: "支払い",
    changeDue: "お釣り",
    printReceipt: "領収書を印刷",
    cancel: "キャンセル",
    complete: "完了",
    edit: "編集",
    delete: "削除",
    update: "更新",
    deleteOrder: "注文を削除",
    printOrderSlip: "注文伝票を印刷",
    printKitchenSlip: "キッチン伝票を印刷",
    latestOrderAt: "最新の注文時刻",
    completedAt: "完了時刻",
    received: "受け取りました",
    startEditing: "編集を開始",
    save: "保存",
    addSmallDiningTable: "小さなダイニングテーブルを追加",
    addMediumDiningTable: "中くらいのダイニングテーブルを追加",
    addLargeDiningTable: "大きなダイニングテーブルを追加",
    clearAll: "全てクリア",
    undo: "元に戻す",
    reorder: "再注文",
    renew: "更新",
    renewSession: "セッションを更新",
    createNewSession: "新しいセッションを作成",
    addSession: "セッションを追加",
    createSession: "セッションを作成",
    printSession: "QRコードを印刷",
    takeOrder: "注文を受ける",
    editOrder: "注文を編集",
    completeOrder: "注文を完了",
    description: "説明",
    ingredients: "材料",
    price: "価格",
    category: "カテゴリー",
    createdDate: "作成日",
    lastUpdated: "最終更新",
    lastUpdatedAt: "最終更新時刻",
    admins: "管理者",
    members: "メンバー",
    invited: "招待された",
    owner: "オーナー",
    member: "メンバー",
    admin: "管理者",
    adminsTooltip: "スーパーアドミン（店のオーナー）のみが管理者ロールを付与および削除できます",
    membersTooltip: "メンバーは顧客の注文を閲覧および管理することのみが許可されています。",
    invitedTooltip: "招待が承諾されると、招待された人々は[メンバー]ロールを与えられます。",
    invitedPeople: "招待された人々",
    transferOwnership: "所有権を譲渡",
    removeAdminRole: "管理者ロールを削除",
    grantAdminRole: "管理者ロールを付与",
    invitePeople: "人を招待",
    addStore: "店を追加",
    alreadyExists: "すでに存在します",
    existingInvitationTo: "既存の招待状へ",
    emailIsRequired: "メールは必須です",
    nameIsRequired: "名前は必須です",
    priceIsRequired: "価格は必須です",
    invalidEmailAddress: "無効なメールアドレスです",
    fullService: "フルサービス",
    limitedService: "限定サービス",
    storeTypeDescription: "店舗タイプの変更は、レジビューで各注文が表示され完了する方法に影響を与えます。",
    limitedServiceDescription: "限定サービスは、1回の提出につき1つの注文として注文を管理します（例：食品/飲料キオスク、フードコート）",
    fullServiceDescription: "フルサービスは、1回のテーブル/セッションにつき1つの注文として注文を管理します（例：レストラン、カフェ）",
    fullServiceExplain: "フルサービスは完全な食事体験を提供し、顧客は通常食後に支払います（例：レストラン、カフェ）",
    limitedServiceExplain: "限定サービスは通常、食事の提供と支払いを食事の前または提供時に終了します（例：食品/飲料キオスク、フードコート）",
    orderIsEmpty: "注文は空です",
    completedByKitchen: "キッチンによって完了",
    changeMealImage: "食事の画像を変更",
    uploadMealImage: "食事の画像をアップロード",
    food: "食品",
    drink: "飲み物",
    side: "サイド",
    submitted: "提出済み",
    confirmDeleteMeal: "食事を削除しますか？",
    confirmRenewSession: "セッションはまだ有効です、更新を確認しますか？",
    confirmCompleteOrder: "注文を完了しますか？",
    confirmDeleteSession: "セッションを削除しますか？",
    confirmDeleteImage: "画像を削除しますか？",
    storeInvitation: "店の招待",
    noInvitationFound: "招待が見つかりませんでした、店の管理者からの承認をリクエストしてください",
    join: "参加する",
    joinStore: "店に参加する",
    settingUpStore: "あなたの店を設定する",
    createStore: "店を作成する",
    invitation: "招待",
    uploadProfilePicture: "プロファイル画像をアップロード",
    changeProfilePicture: "プロファイル画像を変更",
    myStores: "私の店",
    profile: "プロファイル",
    accountSettings: "アカウント設定",
    signOut: "サインアウト",
    deleteStore: "店を削除する",
    cloneStore: "店を複製する",
    uploadImage: "画像をアップロードする",
    temporarySession: "一時的なセッション（24時間以内に期限切れになります）",
    deleteSessionOnCompletion: "注文完了時にセッションを削除",
    autoRenew: "注文完了時にセッションを自動更新（セッションの削除が必要）",
    limitedServiceSession: "限定サービスの運営に合わせてセッションの期限切れと削除が無効にされています、以下でセッションの挙動の設定が可能です",
    noExistingNameFound: "ここでセッションを作成し、次に ",
    ifYouWantLink: "でテーブルを作成して、レイアウトビューでセッションとテーブルをリンクします",
    noOptions: "オプションなし",
    addCustomerGallery: "画面広告/ギャラリーを追加",
    grantAdminRoleToast: "に[管理者]ロールが付与されました",
    removeAdminRoleToast: "がメンバーリストに移動されました",
    deleteInvitationToast: "が招待リストから削除されました",
    deleteMemberToast: "がメンバーリストから削除されました",
    deleteAdminToast: "が管理者リストから削除されました",
    transferOwnershipToast: "店の所有権が転送されました",
    sendInvitationToast: "正常に招待状を送信しました",
    switchedStoreToast: "に切り替えました",
    deleteStoreToast: "正常に削除されました",
    recommendItToCustomer: "顧客にお勧めします",
    emailUs: "お問い合わせはメールで",
    emailUsShort: "メール",
    signup: "サインアップ",
    login: "ログイン",
    quitStore: "店を辞める",
    switchToStore: "店に切り替える",
    changeLogo: "ロゴを変更する",
    uploadLogo: "ロゴをアップロードする",
    emailVerifiedToast: "あなたのメールは確認されました！",
    emailSentToast: "メールが送信されました！",
    emailSentToastDescription: "確認のためメールをチェックしてください",
    emailVerificationErrorToast: "確認メールが既に送信されています",
    emailVerificationFailedToast: "確認メールの送信に失敗しました",
    resetPasswordToast: "ありがとうございます、パスワードをリセットするための指示が記載されたメールを確認してください",
    emailNotExist: "メールが存在しません",
    failedToUpload: "アップロードに失敗しました",
    saveLayoutToast: "テーブルレイアウトが更新されました",
    invalidEmailOrPassword: "無効なメールまたはパスワード",
    failedToLogin: "ログインに失敗しました",
    verificationEmailSent: "メールを確認してください",
    verficiationEmailSentDescription: "アカウント登録プロセスを完了するために、メールアドレスがあなたのものであることを確認する必要があります。",
    emailAlreadyExist: "メールは既に存在します",
    successfullyCreateStore: "店が正常に作成されました",
    pleaseSwitchStore: "、新しい店に切り替えてください。",
    pleaseCreateMeal: "、店のために食事を作成してください。",
    youAreNowMemberOf: "あなたは今、メンバーです",
    orderFromTable: "テーブルから注文",
    isCompleted: "完了しました",
    addedCategory: "カテゴリーが追加されました",
    removedCategory: "カテゴリーが削除されました",
    currencyChanged: "通貨が変更されました",
    successfullyUpdateStore: "店が正常に更新されました",
    storeTypeChanged: "店舗タイプが変更されました",
    layoutNotReady: "レイアウトが準備されていません...",
    layoutNotReadyDescription: "まだレイアウトを作成していないので、店のためのレイアウトを作成してください。",
    createLayout: "レイアウトを作成する",
    confirmQuitStore: "店を辞めることを確認してください？",
    minimumItemQuantity: "注文数量の最小小数点",
    noMoreOrder: "これ以上の注文はありません",
    loadMore: "もっと読み込む",
    id: "ID",
    notifications: "通知",
    noNotificationFound: "通知が見つかりませんでした",
    allowMemberEdit: "メンバーが注文を編集することを許可する",
    storeCreated: "店が作成されました",
    storeCreatedNotification: "店を正常に設定しましたので、店のための食事を作成してください。",
    manageSubscription: "サブスクリプションを管理する",
    billing: "請求",
    currentSubscription: "現在のサブスクリプション",
    mySubscription: "私のサブスクリプション",
    initiateSubscription: "店のオーナーであれば、まず店を作成してください。",
    selectYourStoreType: "店舗タイプを選択してください",
    configureStoreTypeInfo: "どのタイプを選ぶか確信がない場合は、後で店舗タイプを再設定できます。",
    compulsoryItem: "自動的に追加され不変の数量",
    compulsory: "義務的",
    yes: "はい",
    no: "いいえ",
    hiddenFromMenu: "メニューから隠す",
    dashboard: "ダッシュボード",
    addedPaymentMethod: "支払い方法が追加されました",
    removedPaymentMethod: "支払い方法が削除されました",
    paymentMethod: "支払い方法",
    paymentMethods: "支払い方法",
    options: "オプション",
    summarized: "要約された",
    unit: "単位",
    unitPlaceHolder: "表示目的の単位（例：グラム、キログラム、セット）",
    totalAmount: "総額",
    checkout: "チェックアウト",
    back: "戻る",
    close: "閉じる",
    remark: "備考",
    orderSettings: "注文設定",
    paymentKitchenOrder: "先に提供/先に支払い",
    paymentFirst: "先に支払い",
    servedFirst: "先に提供",
    alwaysCompleteAtKitchenView: "支払い先の操作の場合、支払い後は毎回キッチンビューで注文を完了してください。",
    paymentFirstWarning: "フルサービスで支払い先を選択すると、予期しない動作が発生する可能性があります",
    paymentKitchenExplained: "注文が支払い後に削除されないように、支払い先オプションのみを選択してください。これは、スタッフがキッチンビューで情報を読む必要がある場合（例：材料）に役立ちます",
    tableName: "セッション/レイアウトのテーブル名",
    storeOperation: "店舗運営",
    sessionControl: "セッションコントロール",
    all: "全て",
    simple: "シンプル",
    sessionControlExplained: "[シンプル]セッションコントロールでは、[新しいセッションを追加]、[セッションを削除]、[セッションを更新]、[セッションを印刷]を[レジビュー]で行うことができなくなりますので、[シンプル]セッションコントロールに変更する前に、セッション設定を適切に設定してください。",
    none: "なし",
    nearest: "最も近い",
    up: "上",
    down: "下",
    roundingTotal: "合計価格の丸め",
    roundingItem: "アイテム価格の丸め",
    changeTo: "変更先",
    allSessionControl: "完全なセッションコントロール",
    simpleSessionControl: "シンプルなセッションコントロール",
    requiredTableName: "チェックアウト時にスタッフ/顧客にテーブル名の入力を求めます（レイアウトのテーブルに関連していません）",
    pleaseInsertTableName: "テーブル名を入力してください",
    session: "セッション",
    inheritFromStore: "店から継承",
    customerScreen: "顧客スクリーン",
    recentOrders: "最近の注文",
    standard: "スタンダード",
    standardMenuControl: "スタンダードメニューコントロール",
    simpleMenuControl: "シンプルメニューコントロール",
    menuControl: "スタッフメニュー",
    completePaymentFirstAlert: "最初に[レジビュー]で支扈を完了してください",
    detail: "詳細",
    detailNotExists: "注文の詳細はもう存在しません",
    addedRemarkShortcut: "備考ショートカットを追加",
    removedRemarkShortcut: "備考ショートカットを削除",
    remarkShortcuts: "備考ショートカット",
    paymentMethodNameIsRequired: "支払い方法の名前が必要です",
    paymentMethodAlreadyExisted: "支払い方法は既に存在しています",
    categoryNameIsRequired: "カテゴリー名が必要です",
    categoryAlreadyExisted: "カテゴリーは既に存在しています",
    shortcutNameIsRequired: "ショートカット名が必要です",
    shortcutAlreadyExisted: "ショートカットは既に存在しています",
    shortcut: "ショートカット",
    createOption: "オプションを作成",
    optionName: "オプション名",
    requireChange: "支払い時のお釣りの計算が必要",
    menuSettings: "メニュー設定",
    paymentSettings: "支払い設定",
    submittingOrder: "注文を提出中...",
    submittedOrder: "注文が成功に提出されました！",
    addMeal: "食事を追加",
    createdFirstMeal: "最初の食事を作成",
    pleaseUpdateMenu: "最初の食事を正常に作成しました、完全に食事を設定した後ここをクリックしてメニューを更新してください。",
    pleaseCreateSession: "[レジビュー]に進み、最初のセッション/テーブルを作成してください。",
    storeSetupComplete: "店の設定が成功に完了しました",
    moreStoreConfiguration: "注文を受け始めるためにQRコードを押すか、お客様が注文をするためにQRコードを印刷します。[設定]セクションに進み、店の運営に完全に合わせるために特定の店舗設定を更新してください。",
    ok: "OK",
    features: "特徴",
    others: "その他",
    kitchen: "キッチンビュー",
    hasBeen: "が",
    enabled: "有効化されました",
    disabled: "無効化されました",
    untickToDisable: "機能を無効にするためのチェックを外す",
    printAfterCompletion: "注文完了後に印刷",
    userDecide: "ユーザーが決定",
    alreadyAMember: "既にメンバーですか？",
    sign_up: "サインアップ",
    log_in: "ログイン",
    password: "パスワード",
    confirmPassword: "パスワードの確認",
    passwordMustBe6: "パスワードは少なくとも6文字である必要があります",
    required: "必須",
    passwordUnmatched: "パスワードが一致しません",
    forgotPassword: "パスワードを忘れた場合",
    OR: "または",
    signInWithGoogle: "Googleでサインイン",
    forgotPasswordInfo: "リセットリンクが記載されたメールを受け取ります",
    resetPassword: "パスワードをリセット",
    verifyYourEmail: "メールアドレスを確認してください",
    check: "チェック",
    toVerify: "あなたのアカウントを確認して開始します。",
    ifYouHaveNotReceived: "数分後にメールを受け取らない場合は、スパムフォルダを確認してください",
    resendVerificationEmail: "確認メールを再送",
    refresh: "リフレッシュ",
    startNow: "今すぐ始める",
    freeUnlimitedUsers: "無料。無制限のユーザー。",
    etilhubDescription: "あなたのレストランとF&Bビジネスを効率的に運営するための軽量POSソリューション。",
    cloudSmart: "クラウドベース | スマート",
    pointOfSale: "販売点",
    registerForFree: "無料で登録",
    qrFoodOrdering: "QR食事注文",
    contactlessOrders: "非接触注文",
    instantAndEasySetup: "即時かつ簡単な設定",
    adjustableForEveryBusiness: "すべてのF&Bビジネスモデルに適応可能",
    billingProcessingPrinting: "請求処理と印刷",
    orderSlipPrinting: "注文伝票の印刷",
    issueReceipt: "印刷または電子の領収書を発行",
    sessionQRPrinting: "セッションQRコードの印刷",
    instantKitchenView: "即時キッチンビュー",
    realtimeOrderStatus: "リアルタイムの注文状況",
    orderQueue: "注文キュー",
    ingredientsDisplay: "材料表示",
    customizableFloorPlan: "カスタマイズ可能なフロアプラン",
    restaurantTableLayout: "レストランのテーブルレイアウト",
    realtimeTableStatus: "リアルタイムのテーブル状況",
    intuitiveInterface: "直感的なインターフェース",
    moreFeatures: "その他の特徴",
    comingsoon: "近日公開...",
    noItemExist: "アイテムの記録が存在しません",
    myStore: "私の店",
    logout: "ログアウト",
    navigationSettings: "ナビゲーション設定",
    navigateToPaymentAfterSubmit: "注文提出後に支払いに移動します（レジビュー）",
    size: "サイズ",
    small: "小",
    medium: "中",
    large: "大",
    tableNameMustBeSame: "テーブル名はセッション名と同じでなければなりません、ここで最初にテーブルを作成してから店のセッションを作成することができます。",
    confirmDeleteStore: "この店を削除することを確認するために、その名前を入力してください：",
    deleteThisStore: "この店を削除しますか？",
    deleteStoreWarning: "これを行うと、店は永久に削除され、将来的に回復することはできません。",
    pleaseInsertStoreName: "店名を入力してください",
    cloneThisStore: "この店を複製する",
    cloneStoreInfo: "新しい店の詳細を更新してください。",
    addIngredient: "材料を追加する",
    orderUpdatedAt: "テーブルで注文が更新されました",
    simpleMenuInfo: "シンプルメニューは、各食事に複数のオプションを選択することの制限があります。",
    fiverr: "Fiverr",
    bySigningUp: "サインアップすることで、私たちの",
    privacyPolicy: "プライバシーポリシー",
    termsAndConditions: "利用規約",
    and: "および",
    storeExceedSubscriptionLimit: "店の数がサブスクリプションの限界を超えています、より多くの店を追加するためにプランを更新してください。",
    someStoreIsNotShowing: "あなたのサブスクリプションの有効期限が切れたため、一部の店は表示されていません。",
    currentPeriodStart: "現在の期間の開始",
    currentPeriodEnd: "あなたのプランは更新されます",
    planCanceledOn: "あなたのプランはキャンセルされます",
    storeQuantity: "店の数量",
    dailyOrder: "1店舗あたりの日次注文制限",
    perStore: "店舗ごとに",
    createdBy: "作成者",
    completedBy: "完了者",
    monday: "月曜日",
    tuesday: "火曜日",
    wednesday: "水曜日",
    thursday: "木曜日",
    friday: "金曜日",
    saturday: "土曜日",
    sunday: "日曜日",
    morePrices: "オプションでさらに価格",
    moreIngredients: "オプションでさらに材料",
    all_: "全て",
    filter: "フィルター",
    expired: "期限切れ",
    updated: "更新済み",
    limitTime: "制限時間",
    limitDay: "制限日",
    outOfStock: "在庫切れ",
    startFrom: "から開始",
    endAt: "で終了",
    hour: "時間",
    hours: "時間",
    default: "デフォルト",
    cloud: "クラウド",
    printMethod: "印刷方法",
    sessionCreated: "セッションが作成されました",
    orderCreated: "注文が作成されました",
    event: "イベント",
    eventDescription: "すべての印刷ボタン（例：セッションを印刷、注文伝票を印刷、キッチン伝票を印刷、領収書を印刷）はデフォルトでWebhookイベントをトリガーします。Webhookをトリガーする追加のイベントタイプを選択してください",
    endPointDescription: "Webhookを受け取りたいURLを入力してください",
    webhookDescription: "選択されたイベントに対して、このURLにPOSTリクエストを送信し、イベントデータを表すJSONオブジェクトを提供します",
    testEndpointUrl: "エンドポイントURLをテストする",
    failedToPrint: "印刷に失敗しました",
    secretKeyDescription: "シークレットキーは、HTTPボディをHMAC-SHA256で署名するために使用され、X-Hub-Signatureという名前のヘッダーに含まれます",
    outGoingWebhooks: "発信Webhook",
    urlIsRequired: "URLが必要です",
    invalidUrl: "無効なURL",
    endpointUrl: "エンドポイントURL",
    addWebhook: "Webhookを追加",
    confirmDeleteWebhook: "Webhookを削除しますか？",
    printButtonClick: "キッチン",
    takeOrderforTable: "注文",
    addGuestNumber: "ゲスト番号を追加する",
    customerScreen: "顧客スクリーン",
    orderHistory: "注文履歴",
    endSession: "セッションを終了する",
    orderNow: "今すぐ注文する",
    viewMenu: "メニューを見る",
    adults: "大人",
    kids: "子供",
    seniors: "高齢者",
    other: "その他",
    all: "すべて",
    leaveWarning: "本当に去りますか？行った変更は保存されないかもしれません。",
    personAtTable: "テーブルで注文する人",
    bePatient: "辛抱強くお待ちください。",
    checkMenu: "メニューを確認してください。",
    transferOwnership: "所有権を譲渡する",
    transferOwnershipToast: "所有権が譲渡されました",
    cloneItem: "アイテムを複製",
    language: "言語",
    itemPrintName: "アイテムの印刷名",
    serviceFee: "サービス料",
    salesReport: "販売レポート",
    chatPrint: "チャット印刷",
    send: "送信",
    openChatPrint: "チャット印刷を開く",
    deleteCategory: "カテゴリーを削除",
    deleteCategoryConfirmation: "カテゴリーの削除を確認",
    categoryName: "カテゴリー名",
    deleteCategoryWarning: "このカテゴリーを本当に削除しますか？",
    cannotDeleteCategoryWithItems: "アイテムを含むカテゴリーは削除できません",
    totalItems: "合計アイテム数",
    itemsInCategory: "カテゴリー内のアイテム",
    pleaseRemoveItemsFirst: "先にアイテムを削除してください",
    deletionFailed: "削除に失敗しました",
    categoryDeleted: "カテゴリーが削除されました",
    categorySuccessfullyDeleted: "カテゴリーが正常に削除されました",
    errorDeletingCategory: "カテゴリーの削除中にエラーが発生しました",
    anErrorOccurred: "エラーが発生しました",
    verificationEmailSentDescription: "確認メールが送信されました",
    categoryAll: "すべて",
    languageSettings: "言語設定",
    selectLanguagePopupInfo: "起動時のポップアップに表示する言語を選択してください。ただし、システムにアップロードされた各料理の言語を取得する必要があります。",
    languagePopupEnabled: "言語ポップアップを有効にする",
    languageChoiceActive: "言語選択を有効にする",
    selectLanguage: "言語を選択する",
    languageChoiceUpdated: "言語選択が更新されました",
    enterYourName: "お名前を入力してください",
    continue: "続ける",
    othersOrdering: "他の方が注文中です。ぜひご参加ください！",
    nameRequired: "名前が必要です",
    pleaseEnterName: "続行するには名前を入力してください",
    error: "エラー",
    somethingWentWrong: "何か問題が発生しました",
    welcomeBack: "おかえりなさい",
    pleaseWait: "お待ちください",
    sessionCheckInProgress: "セッションチェック進行中",
    noSuchTable: "申し訳ありませんが、そのようなテーブルは存在しません！",
    waitingForStaff: "スタッフがテーブルを開くのを待っています...",
    scanQRCodeAgain: "注文またはメニューにアクセスするには、QRコードを再度スキャンしてください！",
    bonAppetit: "どうぞお召し上がりください！",
    modalSelectLanguage: "言語を選択",
    sessionNotProvided: "セッションが提供されていません",
    noStoreIdProvided: "セッションにストアIDがありません",
    storeNotConfigured: "ストアが見つかりません",
    failedToLoadData: "データの読み込みに失敗しました",
    orderNumber: "注文 #",
    orderCreated: "作成日時",
    orderTotal: "注文合計",
    totalWithTaxes: "税込合計",
    customerName: "名前",
    totalFor: "合計",
    noOrders: "注文なし",
    grandTotal: "総合計",
    pastOrders: "過去の注文",
    poweredBy: "提供",
    closeButton: "閉じる",
    thisSelectionIsRequired: "この選択は必須です",
    pleaseSelectAtLeast: "少なくとも選択してください",
    maximumSelections: "最大",
    selectionsAllowed: "選択可能",
    optionItems: "オプション",
    customizeYourOrder: "注文をカスタマイズ",
    totalExtra: "追加料金合計",
    cancelButton: "キャンセル",
    addToCart: "カートに追加",
    selectExactly: "正確に選択する必要があります",
    singleItem: "項目",
    selectRange: "選択",
    rangeTo: "から",
    selectAtLeast: "少なくとも選択",
    selectUpTo: "最大選択",
    selectMultipleOptional: "複数選択（任意）",
    selectOneRequired: "1つ選択（必須）",
    requiredOption: "必須",
    invalidStoreId: "無効な店舗ID",
    tableRedirectStoreNotFound: "店舗が見つかりません",
    tableRedirectError: "問題が発生しました。もう一度お試しください。",
    loadingTable: "テーブルを検索中...",
    fixedTableQrDisabled: "この店舗では固定テーブルQRコードが無効になっています。",
    contactStaffForHelp: "スタッフにお問い合わせください"
};